import { jobOrderColNm } from "constants/jobOrderConstant"
import { shipmentColNm } from "constants/shipmentConstant"

export const pettyCashApiNm = {
  getPettyCashTable: "/petty-cash/getPettyCashTable",
  getPettyCashDetail: "/petty-cash/getPettyCashDetail",
  getReimbursementData: "/petty-cash/getReimbursementData",
  getJobOrderLocation: "/petty-cash/getJobOrderLocation",
  getPettyCashItem: "/petty-cash/getPettyCashItem",
  getPCJournalAccount: "/petty-cash/getPCJournalAccount",
  getPCTransactionNotCmptByAccId: "/petty-cash/getPCTransactionNotCmptByAccId",
  getPCTransactionNoPrd: "/petty-cash/getPCTransactionNoPrd",
  getPettyCashPeriod: "/petty-cash/getPettyCashPeriod",
  getPCBalance: "/petty-cash/getPCBalance",
  getPettyCashHistory: "/petty-cash/getPettyCashHistory",
  getNoIsCmpt: "/petty-cash/getNoIsCmpt",
  getDriverStatement: "/petty-cash/getDriverStatement",
  getFindClearReceipt: "/petty-cash/getFindClearReceipt",
  checkDocNoExist: "/petty-cash/checkDocNoExist",
  insertPCTransaction: "/petty-cash/insertPCTransaction",
  insertReimbursment: "/petty-cash/insertReimbursment",
  updateReimbursment: "/petty-cash/updateReimbursment",
  updatePCTransaction: "/petty-cash/updatePCTransaction",
  updatePCTransactionCols: "/petty-cash/updatePCTransactionCols",
  insertPCTransactionBulk: "/petty-cash/insertPCTransactionBulk",
  updateIsCmpt: "/petty-cash/updateIsCmpt",
  deletePCTransaction: "/petty-cash/deletePCTransaction",
  deletePCTransactionByJobOrdAndExpId: "/petty-cash/deletePCTransactionByJobOrdAndExpId",
  insertPCItem: "/petty-cash/insertPCItem",
  insertPCItemBulk: "/petty-cash/insertPCItemBulk",
  updatePCItem: "/petty-cash/updatePCItem",
  updatePCItemCols: "/petty-cash/updatePCItemCols",
  deletePCItem: "/petty-cash/deletePCItem",
  insertPettyCashPeriodWithItems: "/petty-cash/insertPettyCashPeriodWithItems",
  updatePettyCashPeriodWithItems: "/petty-cash/updatePettyCashPeriodWithItems",
  updatePCProidCols: "/petty-cash/updatePCProidCols",
  deletePettyCashPeriod: "/petty-cash/deletePettyCashPeriod",
  insertPCJournalAccount: "/petty-cash/insertPCJournalAccount",
  updatePCJournalAccount: "/petty-cash/updatePCJournalAccount",
  deletePCJournalAccount: "/petty-cash/deletePCJournalAccount",
  uploadFilePCItem: "/petty-cash/uploadFilePCItem",
  uploadFilePCTransaction: "/petty-cash/uploadFilePCTransaction",
  deleteFilePCTransaction: "/petty-cash/deleteFilePCTransaction",
  deleteFilePCItem: "/petty-cash/deleteFilePCItem",
  getWTHReport: "/petty-cash/getWTHReport",
}

export const pettyCashColNm = { 
  AdmAccId: "ผู้ทำรายการ",
  AdmNNm: "ผู้ทำรายการ",
  UsrAccId: "ผู้รับเงิน",
  UsrNNm: "ผู้รับเงิน",
  InOutTyp: "รับ/จ่าย",
  ExpId: "รายการ",
  ExpNm: "รายการ",
  PCTrnsTypId: "",
  PCJnlId: "สมุดบัญชี",
  PCJnlNm: "สมุดบัญชี",
  JobOrdId: "เลขที่ใบงาน",
  Loc: "สถานที่วิ่งงาน",
  LocText: "ข้อมูลใบงาน",
  PayTm: "เวลาทำรายการ",
  PCItmTm: "เวลาทำรายการ",
  Dscp: "รายละเอียดเพิ่มเติม",
  AmntB4Vat: "ยอดก่อน Vat",
  Amnt: "จำนวนเงิน",
  InOutAmnt: "จำนวนเงิน",
  VatPrct: "Vat(%)",
  WhtPrct: "หัก ณ ที่จ่าย(%)",
  PayAmnt: "ยอดจ่าย",
  PrPCTrnsId: "รายการหลัก",
  IsCmpt: "รายการเสร็จสิ้นสมบูรณ์",
  IsCost: "ต้นทุน/รายได้",
  Rmk: "หมายเหตุ",
  DocNo: "เลขที่เอกสาร",
  DocDte: "วันที่เอกสาร",
  ItmDte: "วันที่รับเอกสาร",
  ReimDscp: "รายละเอียดเพิ่มเติม",
  ReimRmk: "หมายเหตุ",
  CtrlCd: "เลขที่ควบคุมเอกสาร",
  JobNo: shipmentColNm.JobNo,
  ContNo: jobOrderColNm.ContNo,
  ScId: "ผู้จำหน่าย/รถร่วม",
  SupId: "ผู้จำหน่าย",
  ScSNm: "ผู้จำหน่าย/รถร่วม",
  SupSNm: "ผู้จำหน่าย",
}

export const pettyCashPeriodColNm = {
  PCPrdTm: "เวลายืนยันยอดล่าสุด",
  PCPrdSt: "เวลาเริ่มรายการ",
  PCPrdEn: "เวลาสิ้นสุดรายการ",
  PCJnlId: "สมุดบัญชี",
  PCJnlNm: "สมุดบัญชี",
  InitAmnt: "ยอดเงินเริ่มต้น",
  TrnsAmnt: "ยอดเงินทำรายการ",
  TotalAmnt: "ยอดเงินคงเหลือ",
  FinAmnt: "ยอดเงินคงเหลือจริง",
  DiffAmnt: "ส่วนต่าง(คงเหลือ-เหลือจริง)",
  AdmAccId: "ผู้ทำรายการ",
  AdmNNm: "ผู้ทำรายการ",
  Rmk: "หมายเหตุ",
}